import api from "core/api";
import { AcceptTermsAndAgeRequest, AcceptTermsAndAgeResponse } from "core/api/users/account/acceptTermsAndAge";
import asyncThunk from "core/decorators/toolkit";

export const acceptTermsAndAge = asyncThunk<AcceptTermsAndAgeResponse, AcceptTermsAndAgeRequest, Error>(
  "panel/user/termsAndAge",
  api.users.account.acceptTermsAndAge
);
